module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.sellpoint.business_banner_image != _vm.default_banner_image) ? _c('div', {
    staticClass: "section is-dark",
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    })
  }, [_c('div', {
    staticClass: "container margin-top is-wide"
  }, [_c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('div', {
    staticClass: "text-xsmall text-align-center"
  }, [_c('a', {
    staticClass: "on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")]), _vm._v(" / "), _c('span', {
    staticClass: "low-text-contrast"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "col lg-12 md-12 xs-12"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.sellpoint.business_tagline))]), _vm._v(" "), (_vm.sellpoint.business_profile && (_vm.sellpoint.business_profile != '')) ? _c('p', {
    staticStyle: {
      "height": "80px",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_profile))]) : _vm._e(), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-3 md-4 xs-12 is-sticky stick-cat"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-sidebar-widget"
  }, [_c('h4', {
    staticClass: "margin-bottom"
  }, [_vm._v("Categories")]), _vm._v(" "), _c('ul', {
    staticClass: "c-checklist clist"
  }, _vm._l((_vm.sellpoint.business_categories), function(category) {
    return _c('li', {
      staticClass: "c-checklist_item styl3"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(category.business_category))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "c-sidebar-widget"
  }, [_c('h4', {
    staticClass: "margin-bottom"
  }, [_vm._v("Quick Picks")]), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('a', {
      staticClass: "c-cloud-link",
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_vm._v(_vm._s(product.product_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col lg-9 md-8 xs-12 xs-margin-bottom-double c-stock"
  }, [_c('div', {
    staticClass: "w-layout-grid c-products4x3"
  }, _vm._l((_vm.products), function(product, prdex) {
    return _c('div', [_c('div', {
      staticClass: "c-product-thumb"
    }, [_c('div', {
      staticClass: "c-product-thumb__top"
    }, [_c('a', {
      staticClass: "margin-bottom-small w-inline-block",
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "pimage sp_prd_img",
      attrs: {
        "src": product.product_images[0].product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pimage sp_prd_img",
      attrs: {
        "src": "https://via.placeholder.com/1000x600.png?text=IMAGE 560w",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-xsmall weight-is-medium margin-bottom-small"
    }, [(product.product_category_name != 'error') ? _c('a', {
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_vm._v(_vm._s(product.product_category_name))]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "w-inline-block",
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "c-product__title"
    }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('div', {
      staticClass: "c-product__price-wrapper"
    }, [(product.product_items && (product.product_items.length > 0)) ? _c('div', {
      staticClass: "c-product__price margin-right-small"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), (product.product_items && (product.product_items.length > 0)) ? _c('div', {
      staticClass: "c-product__price is-slashed"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()]), _vm._v(" "), _vm._m(1, true)])])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-sidebar-widget",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "w-form"
  }, [_c('form', {
    attrs: {
      "id": "email-form-2",
      "name": "email-form-2",
      "data-name": "Email Form 2"
    }
  }, [_c('input', {
    staticClass: "form-input-text bg-icon w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "Search",
      "data-name": "Search",
      "placeholder": "Search product",
      "id": "Search"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-product__rating"
  }, [_c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-blank"
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13758c24"}!./src/pages/Sellpoint/Sellpoint/template.html
// module id = 232
// module chunks = 0